import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'rotr',
			hiddenPriceParts: [
				'financeableTotal',
				'total',
				'taxTotal',
				'taxTotalWeight',
				'totalRate',
				'totalWithoutIncentives',
				'importCharge',
				'destinationCharge',
			],
			vatConfig: {
				feature: 'inclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {},
			},
		},
	},
	nextBestActions: [
		{
			description: 'Αναζήτηση Εξουσ. Εμπόρου',
			icon: '',
			labelText: 'Αναζήτηση Εξουσ. Εμπόρου',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://www.audi.gr/gr/web/el/dealer-search.html',
		},
		{
			description: 'Κλείστε ένα test drive',
			icon: 'test-drive',
			labelText: 'Κλείστε ένα test drive',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://www.audi.gr/gr/web/el/models/test-drive.html',
		},
	],
	summaryFooterCta: {
		description: 'Αναζήτηση Εξουσ. Εμπόρου',
		icon: 'send',
		labelText: 'Αναζήτηση Εξουσ. Εμπόρου',
		target: '_blank',

		trackingName: 'contact',
		url: 'https://www.audi.gr/gr/web/el/dealer-search.html',
	},
};
